module.exports = __webpack_public_path__ + "frontend-assets/img/header_image_tablet.c2e87833.png";